import { GENERATION_TYPE_LABELS, getVariantConfig } from '../../../../../shared-generation-pricing-config'
import { ModelDetailSpecStrip } from './ModelDetailSpecStrip'
import type { SpecItem } from './ModelDetailSpecStrip'
import type { GenerationType, PriceUnit } from '../../../../../shared-generation-pricing-config'
import { GENERATION_FAMILY_LABELS, formatPriceUnit } from '@/shared/utils/generationPricing'

interface ModelDetailGenerationSpecsProps {
  baseModel: string
  genType: GenerationType
  priceUnit: PriceUnit
  family: string
  allowedDurations?: Array<string>
}

export function ModelDetailGenerationSpecs({
  baseModel,
  genType,
  priceUnit,
  family,
  allowedDurations,
}: ModelDetailGenerationSpecsProps) {
  // The base model's declared priceUnit is only a default — a specific
  // generation-type variant can override it (e.g. a model priced per-image
  // by default but billed per-second-video for its video variant). Resolve
  // the same way ModelDetailGenerationPricing does so the two can't drift.
  const variant = getVariantConfig(baseModel, genType)
  const resolvedPriceUnit = variant?.priceUnit ?? priceUnit

  const items: Array<SpecItem | null> = [
    { label: 'Type', value: GENERATION_TYPE_LABELS[genType] ?? genType },
    { label: 'Billed', value: formatPriceUnit(resolvedPriceUnit).replace('/ ', 'per ') },
    { label: 'Provider', value: GENERATION_FAMILY_LABELS[family] ?? family },
    allowedDurations && allowedDurations.length > 0
      ? { label: 'Durations', value: allowedDurations.map((d) => `${d}s`).join(' · ') }
      : null,
  ]

  return <ModelDetailSpecStrip items={items.filter((i): i is SpecItem => i !== null)} />
}
